import isBoolean from './isBoolean';
import { createOptionalGuard } from './isOptional';

export default createOptionalGuard<boolean>(isBoolean);
